import { render, staticRenderFns } from "./messageBox.vue?vue&type=template&id=02866d64&scoped=true&"
import script from "./messageBox.vue?vue&type=script&lang=js&"
export * from "./messageBox.vue?vue&type=script&lang=js&"
import style0 from "./messageBox.vue?vue&type=style&index=0&id=02866d64&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02866d64",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
